import { useEffect, useMemo, useState } from 'react';
import { getCustomIndicators, type CustomIndicatorStore } from '../../data-access/customIndicators';
import { interpret } from '@core/sim/indicators/dsl/interpret';
import { CALC_BARS_CAP, MAX_VISIBLE_INDICATORS } from '@core/sim/indicators/dsl/schema';
import type { Candle } from '../sim/PriceChart';
import { toChartSpec } from '../sim/dslChartAdapter';

export type CustomIndicatorRender = {
  key: string;
  pane: 'main' | 'sub';
  spec: ReturnType<typeof toChartSpec>;
};

export function renderCustomIndicators(candles: Candle[], store: CustomIndicatorStore): CustomIndicatorRender[] {
  const calcCandles = candles.slice(-CALC_BARS_CAP);
  const coreCandles = calcCandles.map((c) => ({ open: c.o, high: c.h, low: c.l, close: c.c, volume: c.v }));
  const times = calcCandles.map((c) => c.t);
  return store.items.filter((item) => item.enabled).slice(0, MAX_VISIBLE_INDICATORS).flatMap((item) => {
    try {
      return [{
        key: `${item.id}:${item.updatedAt}`,
        pane: item.pane ?? item.doc.pane ?? 'sub',
        spec: toChartSpec(item.doc, interpret(item.doc, coreCandles), times),
      }];
    } catch {
      return [];
    }
  });
}

export function useCustomIndicatorRender(candles: Candle[]) {
  const [store, setStore] = useState<CustomIndicatorStore>({ version: 1, items: [] });
  useEffect(() => { getCustomIndicators().then(setStore); }, []);
  return useMemo(() => renderCustomIndicators(candles, store), [candles, store]);
}
